import requestAxios from '../../util/requestAxios';

export async function fetchTestLabUserInfo(exigoUserId, token) {
    return requestAxios({
        url: `Account/GetUserInfo/${exigoUserId}`,
        method: 'get',
        token,
    });
}

export async function resetUserAccount({ exigoUserId, name, stepId, token }) {
    return requestAxios({
        url: 'Account/ResetUserAccount',
        method: 'put',
        token,
        data: {
            ExigoUserId: exigoUserId,
            Name: name,
            StepId: stepId,
        },
    });
}

export async function fetchCurrentUserStep(userId, token) {
    return requestAxios({
        url: `customer/GetCurrentUserStep/${userId}`,
        method: 'get',
        token,
    });
}
